module.exports = __webpack_public_path__ + "img/hyhl.a0138875.png";